import { DefaultTheme, ThemeProps } from 'styled-components';
import { rem } from './rem';

export enum TextStyle {
    highlightLarge = 'highlightLarge',
    highlightMedium = 'highlightMedium',
    highlightSmall = 'highlightSmall',
    titleLarge = 'titleLarge', // 700s
    titleLargeStrong = 'titleLargeStrong', // 700s
    titleMedium = 'titleMedium', // 600m
    titleMediumStrong = 'titleMediumStrong', // 600m
    titleSmall = 'titleSmall', // 400r
    titleSmallStrong = 'titleSmallStrong', // 400m
    bodyLarge = 'bodyLarge', // 300r
    bodyLargeStrong = 'bodyLargeStrong', // 300m
    bodyMedium = 'bodyMedium', // 200r
    bodyMediumStrong = 'bodyMediumStrong', // 200m & 200s
    bodySmall = 'bodySmall', // 100r
    bodySmallStrong = 'bodySmallStrong', // 100m & 100s
    bodyExtraSmall = 'bodyExtraSmall',
    bodyExtraSmallStrong = 'bodyExtraSmallStrong',
}

const FONT_FAMILY_FALLBACK =
    "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen-Sans, Ubuntu, Cantarell, 'Helvetica Neue', Helvetica, sans-serif";

export const getTextTokenPreset =
    (textStyle: `${TextStyle}`) =>
    ({ theme }: ThemeProps<DefaultTheme>) => {
        const { fontSize, fontFamily, fontWeight, lineHeight, letterSpacing } = getTextTokenPresetObject(textStyle)({
            theme,
        });

        return `
            font-size: ${fontSize};
            font-family: ${fontFamily};
            font-weight: ${fontWeight};
            line-height: ${lineHeight};
            letter-spacing: ${letterSpacing};
        `;
    };

export const getTextTokenPresetObject =
    (textStyle: `${TextStyle}`) =>
    ({ theme }: ThemeProps<DefaultTheme>) => {
        // eslint-disable-next-line no-restricted-properties
        const { tokens, settings } = theme;

        const { fontSize, fontFamily, fontWeight, lineHeight, letterSpacing } = tokens[textStyle];

        const remFontSize = rem({
            size: fontSize,
            rootSize: settings.rootSize,
        });

        return {
            fontSize: remFontSize,
            fontFamily: `${fontFamily}, ${FONT_FAMILY_FALLBACK}`,
            fontWeight,
            lineHeight,
            letterSpacing,
        };
    };
